// extracted by mini-css-extract-plugin
export default {"consumer-medicaid-lead-item-status":"styles_consumer-medicaid-lead-item-status__SEwT-"};